






































































































































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import OnscreenMenu from "../../components/general/OnscreenMenu.vue";
import MembersMemberDetails from "../members/MembersMemberDetails.vue";

import ListMailAddresses from "../general/ListMailAddresses.vue";

import MemberJson from "../../shared/MemberJson";
import { MemberStatus, MemberStatusNames } from "../../shared/MemberStatus";
import { MembershipType } from "../../shared/MembershipType";
import { MembershipRenewInterval } from "../../shared/MembershipRenewInterval";
import { MembershipTypeNames } from "../../shared/MembershipType";
import { MembershipRenewIntervalNames } from "../../shared/MembershipRenewInterval";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

import GeneralInfos from "../custom/GeneralInfos";

export default Vue.extend({
  name: "MembersAll",
  components: {
    Loading,
    OnscreenMenu,
    ListMailAddresses,
    TableView,
    MembersMemberDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      GeneralInfos: GeneralInfos,
      MemberStatus: MemberStatus,
      MemberStatusNames: MemberStatusNames,
      MembershipType: MembershipType,
      MembershipTypeNames: MembershipTypeNames,
      MembershipRenewIntervalNames: MembershipRenewIntervalNames,
      showMailAddressesList: false,
      mailAddressesList: [] as string[],
      useFilters: false as boolean,
      filterType: null as MembershipType | null,
      filterState: null as MemberStatus | null,
      filterRenew: null as boolean | null,
      showDetails: false,
      detailsMode: "read",
      allMembers: null as MemberJson[] | null,
      searchString: "",
      selectedMemberId: null as number | null,
      isExporting: false,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.reloadData();
      }
    },

    openDetails(item: MemberJson | null, mode: string) {
      if (item != null) {
        this.selectedMemberId = item.ID;
      } else {
        this.selectedMemberId = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },
    /*** END: details view ***/

    loadData() {
      this.loadAllMembers();
    },

    async loadAllMembers() {
      this.allMembers = null;
      this.selectedMemberId = null;

      if (this.restClient != null) {
        try {
          this.allMembers = await this.restClient.getMembers();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async reloadData() {
      this.loadAllMembers();
    },

    applyUseFilters() {
      this.useFilters = true;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();
    },

    removeUseFilters() {
      this.useFilters = false;

      this.filterType = null;
      this.filterState = null;
      this.filterRenew = null;
      (this.$refs.filterMenu as any).toggleOnscreenMenu();
    },

    //export list
    async downloadMembersList() {
      this.isExporting = true;

      try {
        var data = await this.restClient.downloadMemberListArchive(this.filterType, this.filterState, this.filterRenew);
        if (data != null) {
          let atag = document.createElement("a");
          atag.style.display = "none";
          document.body.appendChild(atag);

          let blob = new Blob([data], { type: "octet/stream" });
          let url = window.URL.createObjectURL(blob);

          atag.href = url;
          //todo: besserer Dateiname
          atag.download = "mitglieder.csv";
          atag.click();
          window.URL.revokeObjectURL(url);

          this.isExporting = false;
        }
      } catch (e) {
        this.isExporting = false;
        alert(e.message);
      }
    },

    // Mails
    sendMail() {
      if (this.filteredAllMembers) {
        this.mailAddressesList = [];
        var mailtoString = "mailto:" + GeneralInfos.email;

        mailtoString += "?bcc=";

        for (let i = 0; i < this.filteredAllMembers.length; i++) {
          let mailAddress = this.filteredAllMembers[i].customers[0].email;

          if (!this.mailAddressesList.includes(mailAddress) && mailAddress != "") {
            this.mailAddressesList.push(mailAddress);
          }
        }

        mailtoString += this.mailAddressesList.join(";");

        if (mailtoString.length < 2048) {
          window.location.href = mailtoString;
          //window.open(mailtoString, "_blank")
        } else {
          alert(
            "Die E-Mail Vorlage an alle Teilnehmenden konnte leider nicht automatisch erstellt werden. Im folgenden werden die E-Mail Adressen zum kopieren angezeigt."
          );
          this.showMailAddressesList = true;
        }
      }
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    permissionAbleManagement: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    memberColumns: function (): TableViewColumnDefinitions<MemberJson>[] {
      let vue = this;

      return [
        {
          th: "Nr.",
          td: (i) => i.ID,
        },
        {
          th: "Name",
          td: (i) =>
            i.customers.length > 0 ? i.customers[0].guardianLastName + ", " + i.customers[0].guardianFirstName : "--",
        },
        {
          th: "Art",
          td: (i) => vue.MembershipTypeNames[i.membershipType],
        },
        {
          th: "Status",
          td: (i) => vue.MemberStatusNames[i.state],
        },
        {
          th: "Automatisch Verlängerung",
          td: (i) => vue.MembershipRenewIntervalNames[i.renewInterval],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<MemberJson>[];
    },

    allMembersCount(): number {
      let count = 0;

      if (this.filteredAllMembers !== undefined) {
        count = this.filteredAllMembers.length;
      }

      return count;
    },

    filteredAllMembers(): MemberJson[] | undefined {
      if (this.allMembers != null) {
        var members: MemberJson[] = this.allMembers as MemberJson[];

        //filters
        if (this.useFilters) {
          if (this.filterType != null) {
            members = members.filter((i) => i.membershipType == this.filterType);
          }
          if (this.filterState != null) {
            members = members.filter((i) => i.state == this.filterState);
          }
          if (this.filterRenew != null) {
            members = members.filter((i) =>
              this.filterRenew
                ? i.renewInterval != MembershipRenewInterval.none
                : i.renewInterval == MembershipRenewInterval.none
            );
          }
        }

        //search
        var tokens = this.searchString
          .split(" ")
          .map((t) => t.trim().toLowerCase())
          .filter((t) => t.length > 0);

        for (var token of tokens) {
          members = members.filter((i) => {
            if (
              i.customers[0].guardianFirstName.toLowerCase().includes(token) ||
              i.customers[0].guardianLastName.toLowerCase().includes(token) ||
              i.ID?.toString().includes(token)
            ) {
              return true;
            }

            if (i.membershipTerms.length > 0) {
              if (
                i.membershipTerms.find((j) =>
                  j.invoiceInfos ? j.invoiceInfos.find((k) => k.invoiceNumber.toLowerCase().includes(token)) : false
                )
              ) {
                return true;
              }
            }

            return false;
          });
        }

        return members;
      }
    },
  },
});
